import { render, staticRenderFns } from "./addcoupons.vue?vue&type=template&id=1a4bc65a&scoped=true"
import script from "./addcoupons.vue?vue&type=script&lang=js"
export * from "./addcoupons.vue?vue&type=script&lang=js"
import style0 from "./addcoupons.vue?vue&type=style&index=0&id=1a4bc65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bc65a",
  null
  
)

export default component.exports